import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { Switch } from "@material-ui/core";

import { SUCCESS_STATUS } from "components/MessageService/constants";

import { saveClient } from "store/client/actions";

const ClientActiveSwitch = ({ item }) => {
  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState(null);
  const [isActive, setIsActive] = useState(item.status === "active");
  const [isLoading, setIsLoading] = useState(false);

  const { messagePayload } = useSelector(({ helperReducer }) => helperReducer);

  useEffect(() => {
    if (messagePayload) {
      toggleSwitch(messagePayload.type === SUCCESS_STATUS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagePayload]);

  const handleActiveStatus = () => {
    setSelectedItem(item._id);
    setIsLoading(true);

    const newStatus = isActive ? "inactive" : "active";
    dispatch(saveClient({ ...item, status: newStatus }, item._id, false));
  };

  const toggleSwitch = (success) => {
    if (selectedItem === item._id) {
      setIsLoading(false);
      setSelectedItem(null);

      if (success) {
        setIsActive((isActive) => !isActive);
      }
    }
  };

  return (
    <Switch
      checked={isActive}
      onChange={handleActiveStatus}
      disabled={isLoading}
    />
  );
};

ClientActiveSwitch.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ClientActiveSwitch;

